import { useMemo } from "react";
import {
  CarNavigationFlow,
  type CoreCarSteps,
  useCarNavigationFlow,
} from "~core-cars/utilities";

interface UseCarBreadcrumbsOptions {
  currentStep: CoreCarSteps;
}

interface BreadcrumbStepData {
  step: string;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

export const useCarBreadcrumbs = ({
  currentStep,
}: UseCarBreadcrumbsOptions) => {
  const goToStep = CarNavigationFlow.useGoToStep();

  const {
    flow: { stepOrder, steps },
  } = useCarNavigationFlow();

  const breadcrumbSteps = useMemo(() => {
    return stepOrder.reduce<BreadcrumbStepData[]>((acc, stepId) => {
      const step = steps[stepId];

      if (step.breadcrumb != null) {
        acc.push({
          step: stepId,
          label: step.breadcrumb.label,
          onClick: () => goToStep(stepId, false),
          isSelected: stepId === currentStep,
        });
      }
      return acc;
    }, []);
  }, [currentStep, goToStep, stepOrder, steps]);

  return { steps: breadcrumbSteps };
};
